export default "__VITE_ASSET__800df565__"